const MonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const CRMS = {
  7001: 'hubspot',
  7002: 'salesforce',
};
export { MonthNames, CRMS };
